import React from 'react'
import { Heading, Image, Modal } from 'lib/ui'

const ForwardedImage = React.forwardRef(function ForwardedImage(props, ref) {
  return <Image ref={ref} {...props} />
})

const Images = ({ data }) => {
  return (
    <Image.Group size="small">
      {data.map(img => (
        <Modal
          key={img.url}
          trigger={
            <ForwardedImage
              src={img.url}
              alt={img.title || ''}
              as="a"
              className="hover:cursor-pointer"
            />
          }
          basic
          closeIcon
          closeOnDocumentClick
        >
          <Modal.Title>
            <Heading content={img.title} />
          </Modal.Title>
          <Modal.Content>
            <ForwardedImage src={img.url} alt={img.title || ''} centered />
          </Modal.Content>
        </Modal>
      ))}
    </Image.Group>
  )
}

export default Images
